import { render, staticRenderFns } from "./infoHeader.vue?vue&type=template&id=65156472&scoped=true"
import script from "./infoHeader.vue?vue&type=script&lang=js"
export * from "./infoHeader.vue?vue&type=script&lang=js"
import style0 from "./infoHeader.vue?vue&type=style&index=0&id=65156472&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65156472",
  null
  
)

export default component.exports